import { loadStripe, Stripe } from '@stripe/stripe-js';
import { configSettings, getConfiguration } from '../../shared/configuration/config-settings';

const USE_LOCAL_PAYMENT_API = false;
const LOCAL_PAYMENT_API_URL = 'http://localhost:8086';
const LOCAL_API_PATH_PREFIX = '/qa/v3';
const REMOTE_API_PATH_PREFIX = '/payments/v3';

export const getPaymentApiBaseUrl = (): string => {
  if (USE_LOCAL_PAYMENT_API) {
    return LOCAL_PAYMENT_API_URL;
  }
  return configSettings.unified_aws_app_gateway_uri;
};

export const getPaymentApiPathPrefix = (): string => {
  return USE_LOCAL_PAYMENT_API ? LOCAL_API_PATH_PREFIX : REMOTE_API_PATH_PREFIX;
};

const config = getConfiguration();
let stripePromise: Promise<Stripe | null> | null = null;

export const getStripeInstance = async (): Promise<Stripe | null> => {
  if (!stripePromise && config.stripe_key) {
    stripePromise = loadStripe(config.stripe_key);
  }
  return stripePromise;
};
